import { motion } from 'framer-motion';

const fadeUp = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-50px' },
    transition: { duration: 0.6, ease: 'easeOut' },
};

export function WhoElseSection() {
    return (
        <section data-testid="who-else-section" className="bg-[#F8F9FA] py-20">
            <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 mb-4 tracking-tight">
                        Built for Real Estate. Works Across the Industry.
                    </h2>
                    <p className="text-[#6B7280] text-lg leading-relaxed">
                        We work with agents, team leaders, and the professionals who support them - mortgage brokers, title reps, builders, inspectors, electricians, and other relationship-based businesses. If your growth is limited by how much you personally can do, we built this for you.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
